import { Component, Ref } from 'vue-property-decorator'
import ConfigurationSectionHeader from '@/modules/configurationModule/ConfigurationSectionHeader.vue'
import VtGrid from '@/components/VtGrid/VtGrid.vue'
import ConfigurationAutomationPersonnelEntitiesAssociationModal
    from '@/modules/configurationModule/detail/automation/personnel/entities-association/components/modal/configuration-automation-personnel-entities-association-modal.vue'
import BaseCrudServerSideComponent from '@/shared/resources/base-crud-server-side.component'
import {
    ConfigurationPersonnelPatchInBatchRequest,
    ConfigurationPersonnelResponse
} from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel/configuration-personnel.dto'
import { BaseCrud } from '@/shared/models/cruds.models'
import ModalWrapper from '@/components/ModalWrapper.vue'
import {
    columnsDefAutomationPersonnelEntitiesAssociationGrid,
    ConfigurationAutomationPersonnelEntitiesAssociationGridState,
    initialConfigurationAutomationPersonnelEntitiesAssociationGridState
} from '@/modules/configurationModule/detail/automation/personnel/entities-association/components/grid/configuration-automation-personnel-entities-association-grid.model'
import {
    ColDef,
    ColGroupDef,
    GetContextMenuItemsParams,
    MenuItemDef
} from '@ag-grid-enterprise/all-modules'
import { EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

@Component({
    components: {
        ConfigurationSectionHeader,
        VtGrid,
        ConfigurationAutomationPersonnelEntitiesAssociationModal
    }
})
export default class ConfigurationAutomationPersonnelEntitiesAssociationGrid extends BaseCrudServerSideComponent<ConfigurationPersonnelResponse> implements BaseCrud {
    @Ref() readonly entitiesAssociationModalWrapper!: typeof ModalWrapper

    state: ConfigurationAutomationPersonnelEntitiesAssociationGridState

    get canAssociate(): boolean {
        return this.state.selectedRows.length === 1
    }

    constructor() {
        super()
        this.state = initialConfigurationAutomationPersonnelEntitiesAssociationGridState()
    }

    /// SERVICES CALLS ///

    private async _patchPersonnel(batchRequests: ConfigurationPersonnelPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[] | null> {
        if (batchRequests) {
            const response = await this.$_toCallUnique(this.state.service.patch(batchRequests))
            if (response) {
                const elements = batchRequests.length - response.length
                if (elements > 0) {
                    const choice = elements > 1 ? 2 : 1
                    this.$_showToastSuccess(this.$tc('configuration.toastMessages.updated', choice, { elements }))
                }
                return response
            }
        }
        return null
    }

    /// GRID API ///

    get columnDefs(): (ColDef | ColGroupDef)[] {
        if (!this.$_globalParameters?.middleNameSupported) {
            return columnsDefAutomationPersonnelEntitiesAssociationGrid().filter(col => col.field !== 'middleName')
        }
        return columnsDefAutomationPersonnelEntitiesAssociationGrid()
    }

    /// GRID OPERATIONS ///

    async patchOperation(batchRequest: ConfigurationPersonnelPatchInBatchRequest): Promise<void> {
        if (batchRequest) {
            if (await this._patchPersonnel([batchRequest])) {
                this.reloadData()
            }
        }
    }

    /// GRID EVENT HANDLERS ///

    onAssociate(personnel: ConfigurationPersonnelResponse = this.state.gridApi?.getSelectedRows()[0]): void {
        if (personnel) {
            this.showModal(this.$tc('configuration.actions.associate'), personnel, this.entitiesAssociationModalWrapper)
        }
    }

    getContextMenuItems(params: GetContextMenuItemsParams): MenuItemDef[] {
        return [
            {
                name: this.$tc('configuration.actions.associate'),
                cssClasses: this.state.selectedRows.length > 1 ? ['not-show'] : [''],
                action: () => this.onAssociate(params?.node?.data)
            }
        ]
    }
}
